import { Box, Button, makeStyles, Typography } from '@material-ui/core';
import { blueGrey } from '@material-ui/core/colors';
import CheckIcon from "@material-ui/icons/Check";
import React from 'react';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    wrapper: {
        display: 'flex',
        gap: '1rem',
        alignItems: 'center'
    },
    stepNumberWrapper: {
        display: 'flex',
        width: '24px',
        height: '24px',
        backgroundColor: '#D7D7D7',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
        '&.actual-step-pending': {
            backgroundColor: '#ED0030',
            color: '#FFFFFF'
        },
        '&.done': {
            backgroundColor: '#238C4F',
            color: '#FFFFFF'
        }
    },
    title: {
        color: '#737373',
        fontWeight: '700',
        '&.done': {
            color: 'rgba(26, 26, 26, 0.87)'
        }
    },
    subTitle: {
        fontSize: '14px'
    },
    button: {
        width: '200px',
        height: '35px',
        backgroundColor: blueGrey[900],
        color: "#fff",
        "&:hover": {
            backgroundColor: blueGrey[800],
        },
        [theme.breakpoints.down("sm")]: {
            paddingRight: 0,
            paddingLeft: 0,
        },
    },
    iconSize: {
        width: '16px',
        height: '16px'
    }
}));

const stepLocale = {
    IMPRIMIR_NOTA_FISCAL: {
        step: 1,
        PENDING: {
            title: 'Aguardando a emissão da nota fiscal',
        },
        DONE: {
            title: 'Imprima a nota fiscal',
        },
        subTitle: 'Aguarde a emissão da nota, imprima o documento e coloque junto ao pacote.',
        buttonText: 'Imprimir nota fiscal'
    },
    IMPRIMIR_ETIQUETA: {
        step: 2,
        PENDING: {
            title: 'Aguardando a emissão da etiqueta de transporte',
        },
        DONE: {
            title: 'Imprima a etiqueta de transporte',
        },
        subTitle: 'Após a impressão da nota, imprima a etiqueta de transporte e cole na parte externa do pacote.',
        buttonText: 'Imprimir etiqueta'
    }
}

const Step = ({ tipo, status, isPreviousEventPending, onAction, disabled }) => {
    const classes = useStyles();

    const statusClasses =
        status === 'DONE'
            ? 'done'
            : !isPreviousEventPending
                ? 'actual-step-pending'
                : '';

    return (
        <Box className={classes.container}>
            <Box className={classes.wrapper}>
                <Box className={`${classes.stepNumberWrapper} ${statusClasses}`}>
                    {status === 'DONE' ? <CheckIcon className={classes.iconSize} /> : stepLocale[tipo].step}
                </Box>
                <Box>
                    <Typography variant='body1' className={`${classes.title} ${isPreviousEventPending ? '' : 'done'}`}>{stepLocale[tipo][isPreviousEventPending ? 'PENDING' : 'DONE'].title}</Typography>
                    <Typography variant='subtitle1' className={classes.subTitle}>{stepLocale[tipo].subTitle}</Typography>
                </Box>
            </Box>
            <Button
                variant="contained"
                disableElevation
                className={classes.button}
                disabled={isPreviousEventPending || disabled}
                onClick={onAction}
            >
                {stepLocale[tipo].buttonText}
            </Button>
        </Box>
    );
};

export default Step;